export type MarketplaceConnectionState = "connected" | "reconnect" | "disconnected";
export type MarketplaceActivityFilter = "all" | "active" | "inactive";
export type MarketplaceChannel = "erp" | "chat";

export const MARKETPLACE_TYPES = ["shopee", "lazada", "tokopedia", "tiktok", "blibli", "bukalapak"] as const;

export type MarketplaceCredential = {
  connectedAt?: unknown;
  accessTokenExpired?: unknown;
  expiredIn?: unknown;
  partnerID?: string;
  partnerKey?: string;
};

export type MarketplaceAccount = {
  id: string;
  type: string;
  name?: string;
  searchKey?: string;
  marketplaceShopId?: string;
  marketplace_url?: string;
  district?: string;
  city?: string;
  province?: string;
  warehouse?: string;
  logo_url?: string;
  isActive?: boolean;
  updatedAt?: unknown;
  createdAt?: unknown;
  credentials?: {
    erp?: MarketplaceCredential;
    chat?: MarketplaceCredential;
  };
  [key: string]: unknown;
};

export type MarketplaceListRequest = {
  clientId: string;
  activity: MarketplaceActivityFilter;
  marketplaceTypes: string[];
  search: string;
  page: number;
  pageSize: number;
  sort: "updatedAt" | "name" | "type";
  sortDirection: "asc" | "desc";
};

export type MarketplaceListResult = {
  items: MarketplaceAccount[];
  total: number;
};
